"use strict";
function CNPJ(cnpj) {
    return {
        raw: cnpj,
        get validate() {
            if (!cnpj)
                return false;
            const regex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
            return regex.test(this.mask);
        },
        get mask() {
            if (!cnpj)
                return "";
            return cnpj
                .replace(/\D+/g, "")
                .replace(/(\d{2})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .replace(/(-\d{2})\d+?$/, "$1");
        },
        get maskByEnd() {
            if (!cnpj)
                return "";
            const invertString = (data) => data.split("").reverse().join("");
            const slashParse = cnpj.replace(/(\d)(000[\d])(\d)/, "$1/$2-$3");
            const [beforeSlash, afterSlash] = slashParse.split("/");
            const inverse = invertString(beforeSlash);
            const maskedBeforeSlash = inverse.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2");
            return `${invertString(maskedBeforeSlash)}/${afterSlash}`;
        },
        get unmask() {
            if (!cnpj)
                return "";
            return (cnpj.match(/\d/g) || [""]).join("");
        },
    };
}
window.CNPJ = CNPJ;
//# sourceMappingURL=index.js.map